import React, { forwardRef } from "react";
import styles from "./Divider.scss";

export const Divider = forwardRef(({ ...restProps }, ref) => (
  <div ref={ref} className={`${styles.divider}`} {...restProps} />
));

Divider.displayName = "Divider";

export default Divider;
